import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const PlayersOnlineModal = ({ open, players = [], onClose }) => (
    <Modal open={open} onClose={onClose}>
        <Paper
            sx={{
                padding: 3,
                maxWidth: 500,
                width: "90%",
                margin: "auto",
                mt: "10vh",
                maxHeight: "80vh",
                overflow: "auto",
                backgroundColor: "background.paper",
                color: "text.primary",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="h6">Игроки онлайн ({players.length})</Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>

            {players.length > 0 ? (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {players.map((player, index) => (
                        <Chip
                            key={index}
                            label={player.name}
                            variant="outlined"
                            sx={{ backgroundColor: "action.hover", borderColor: "divider", color: "text.primary" }}
                        />
                    ))}
                </Box>
            ) : (
                <Typography>На сервере нет игроков онлайн</Typography>
            )}
        </Paper>
    </Modal>
);

export default PlayersOnlineModal;
